import { PlanType } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

import { assertUnreachable } from '../../../../util/assertUnreachable';

/**
 * Get the max seat count for a given plan type
 * null represents that there is no limit.
 * Example free doesn't have any seats at all since it is not a paid account
 * pro has unlimited seats.
 * @param planType
 */
export function getMaxSeatCount(planType: PlanType) {
  if (!planType) {
    return 0;
  }

  switch (planType) {
    case PlanType.Free:
    case PlanType.FreeLegacy: {
      return 0;
    }
    case PlanType.Essentials:
    case PlanType.LegacyPro:
    case PlanType.Starter: {
      return 1;
    }
    case PlanType.Pro: {
      return 500;
    }
    case PlanType.Complete:
    case PlanType.Organization: {
      return Infinity;
    }
    default:
      if (__DEV__) {
        assertUnreachable(planType);
      }
      return null;
  }
}

export function useMaxSeatCountForSelectedTeamSubscription() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  return useTeams({
    select: (teams) => {
      const team = teams.find((team) => team.id === selectedTeamId);
      const planType = team?.subscription?.plan ?? PlanType.Free;

      return {
        maxSeats: getMaxSeatCount(planType),
        planType: planType,
      };
    },
  });
}
